import { render } from "./kd-button.vue?vue&type=template&id=e4ca6910"
import script from "./kd-button.vue?vue&type=script&lang=js"
export * from "./kd-button.vue?vue&type=script&lang=js"

import "./kd-button.vue?vue&type=style&index=0&id=e4ca6910&lang=scss"
script.render = render

export default script